import BaseAuthenticator from 'ember-simple-auth/authenticators/base';
import config from 'sh-www/config/environment';
import { inject as service } from '@ember/service';
import { STORAGE_KEYS } from 'sh-www/services/local-storage-fallback';
import { run } from '@ember/runloop';
import { blockingLocationAssign } from 'sh-www/utils/window';

export default class SimpleAuthenticator extends BaseAuthenticator
{
  @service('state-manager-hybrids.heartbeat-state-manager-hybrid')
  heartbeatHybrid;

  @service('commands.user-commands')
  userCommandService;

  @service('error-tracker')
  errorTracker;

  @service
  api;

  @service
  session;

  @service('local-storage-fallback')
  storage;

  @service cookies;

  /** @inheritDoc */
  restore(data) {
    if (config.DEBUG) {
      console.log("AUTH - Restoring");
    }

    const valid = this.cookies.exists('glimmer_session_check');
    if (valid) {
      const currentSessionUserId = this.session.data?.authenticated?.sessionUserId;
      if (currentSessionUserId && currentSessionUserId !== data.sessionUserId) {
        // We have an authenticated session, but we are switching users
        return blockingLocationAssign('/start');
      }

      return Promise.resolve(data);
    } else {
      return Promise.reject(Error('Failed to restore'));
    }
  }

  /** @inheritDoc */
  async authenticate() {
    if (config.DEBUG) {
      console.log(`AUTH - Authenticating`);
    }

    const currentUser = await this.session.loadCurrentUser();

    if (!currentUser) {
      throw new Error('Failed to authenticate');
    }

    return { sessionUserId: currentUser.id };
  }

  /** @inheritDoc */
  async invalidate() {
    if (config.DEBUG) {
      console.log(`AUTH - Invalidating`);
    }

    this.heartbeatHybrid.stop();

    const jsonData = {};
    const deviceID = window.SH_DEVICE_DATA?.deviceID;
    if (deviceID) {
      jsonData['device-id'] = deviceID;
    }

    try {
      await this.api.post('auth/logout', { jsonData });
    } finally {
      this.cookies.clear('glimmer_session_check');
      this.cookies.clear('ember_simple_auth:session'); // temporary until migration complete
      this.storage.removeItem(STORAGE_KEYS.MASQUERADE_ORIG_AUTH);
    }
  }
}
